<template>
  <div class="col-lg-3 col-md-4 col-12">
    <div class="category-sidebar">
      <!-- Start Single Widget -->
      <div class="single-widget search">
        <h3>Search By Name</h3>
        <form>
          <input
            v-model="name"
            type="text"
            placeholder="Keyword(s)"
          />
        </form>
      </div>
      <!-- End Single Widget -->
      <!-- Start Single Widget -->
      <div class="single-widget condition">
        <h3>Filter By Category</h3>
        <div
          class="form-check"
          v-for="category in categories"
          :key="category.id"
        >
          <input
            class="form-check-input"
            type="checkbox"
            :value="category.id"
            v-model="selectedCategory"
          />
          <label class="form-check-label">{{ category.name }} </label>
        </div>
      </div>
      <!-- End Single Widget -->
      <!-- Start Single Widget -->
      <div class="single-widget search">
        <h3>Filter By Price</h3>
        <form>
          <input v-model="min" type="number" placeholder="Min Price" />
          <br /><br />
          <input v-model="max" type="number" placeholder="Max Price" />
        </form>
      </div>
      <!-- End Single Widget -->
      <div class="col-12">
        <div class="button">
          <button @click="filterList" type="button" class="btn">
            Submit Search
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterComponent",
  data() {
    return {
      name: "",
      min: null,
      max: null,
      selectedCategory: [],
    };
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
  },
  methods: {
    filterList() {
      let filter = [];
      if (this.name) {
        filter.push(`name=${this.name.split(" ").join(",")}`);
      }
      if (this.selectedCategory.length > 0) {
        filter.push(`category=${this.selectedCategory.join(",")}`);
      }
      if (this.min) {
        filter.push(`min=${this.min}`);
      }
      if (this.max) {
        filter.push(`max=${this.max}`);
      }
      let query = `/?${filter.join("&")}`;
      this.$router.push(query).catch(()=>{}),
      this.$store.commit('SET_SEARCH_QUERY', query),
        (this.name = ""),
        (this.min = null),
        (this.max = null),
        (this.selectedCategory = []),
        this.$store.dispatch("fetchProducts");
    },
  },
  created() {
    this.$store.dispatch("fetchCategories");
    this.$store.dispatch("fetchProducts");
  },
};
</script>

<style>
</style>